import React from 'react'

const Training = () => {
    return (
        <div>
            <h2>Training offers:</h2>
            <p>3months : <span>$3,000</span></p>
            <p>6months : <span>$6,000</span></p>
            <p>1year : <span>$10,000</span></p>
        </div>
    )
}

export default Training
